import { useNavigate, Link } from "react-router-dom";
import {useState} from 'react'

export const Nav = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  function logout() {
    localStorage.clear();
    navigate("/admin/login");
  }
  return (
    <nav className="bg-gray-700">
			<div className="px-4">
				<div className="flex justify-between">
					<div className="flex space-x-7">
						<div className="hidden md:flex items-center space-x-1">
							<Link to="/admin" className="py-4 px-2 text-white font-semibold hover:text-green-500">Trắc nghiệm</Link>
							<Link to="/admin/simulation" className="py-4 px-2 text-white font-semibold hover:text-green-500">Mô phỏng</Link>
							<Link to="/admin/simulation/exam" className="py-4 px-2 text-white font-semibold hover:text-green-500">Bài thi Mô phỏng</Link>
							<Link to="/admin/user" className="py-4 px-2 text-white font-semibold hover:text-green-500">Tài khoản</Link>
							<Link to='/admin/resource' className="py-4 px-2 text-white font-semibold hover:text-green-500">Tài nguyên</Link>
							<Link onClick={logout} className="py-4 px-2 text-white font-semibold hover:text-green-500">Đăng xuất</Link>
						</div>
					</div>
					<div className="md:hidden flex items-center">
						<button onClick={() => setShow(!show)} className="outline-none mobile-menu-button p-2">
						<svg className=" w-6 h-6 text-white hover:text-green-500 "
							x-show="!showMenu"
							fill="none"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path d="M4 6h16M4 12h16M4 18h16"></path>
						</svg>
					</button>
					</div>
				</div>
			</div>
			<div className={show ? 'mobile-menu' : 'hidden mobile-menu'}>
				<ul className="">
					<li><Link href="#services" className="block text-white text-sm px-2 py-4">Thi trắc nghiệm</Link></li>
					<li><Link href="#about" className="block text-white text-sm px-2 py-4">Thi thử tình huống</Link></li>
					<li><Link href="#contact" className="block text-white text-sm px-2 py-4">Tình huống</Link></li>
				</ul>
			</div>
		</nav>
  );
};
